import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const paymentCreateSlice = createApi({
    reducerPath: "paymentCreate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        paymentCreate: builder.mutation({
            query: (data) => ({ url: "/order-management/api/v1/payment/create", method: "POST", body: data }),
        }),
    }),
});

export const { usePaymentCreateMutation } = paymentCreateSlice;
